import React from 'react';

const HTMLRender: React.FC = ({ children }) => (
    <div dangerouslySetInnerHTML={{ __html: children as string }}></div>
);

export default HTMLRender;